import React from 'react';

export const amountHighlightClassName =
  'bg-amount-gold-text bg-clip-text text-transparent [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]';

export const amountHighlightStyle: React.CSSProperties = {
  display: 'inline-block',
  maxWidth: '100%',
  color: 'var(--amount-gold-solid)',
  backgroundImage: 'var(--amount-gold-gradient)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

export interface AmountHighlightProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode;
}

const AmountHighlight: React.FC<AmountHighlightProps> = ({
  children,
  className = '',
  style,
  ...props
}) => (
  <span
    className={[amountHighlightClassName, className].filter(Boolean).join(' ')}
    style={{...amountHighlightStyle, ...style}}
    {...props}>
    {children}
  </span>
);

export default AmountHighlight;
